// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Montserrat:300,700);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
	font-family: Montserrat, Arial, Helvetica, sans-serif;
	font-size: 18px;
	color: #535253;
}
div.container {
	position: relative;
	font-size: 20px;
	margin: auto;
}
.banner {
	margin: auto;
	width: 100%;
	height: 100px;
}

.content {
	margin: auto;
	max-width: 620px;
	padding: 86px 30px 30px;
}
h1 {
	font-family: Montserrat, Arial, Helvetica, sans-serif;
	font-size: 36px;
	font-weight: bold;
	color: #36296f;
	margin: 0 0 30px;
}

h2 {
	font-family: Montserrat, Arial, Helvetica, sans-serif;
	font-size: 25px;
	font-weight: bold;
	color: #2bb673;
}

hr {
	border: none;
	border-bottom: solid 1px #dadada;
	margin: 34px 0;
}

p {
	margin: 0 0 1em;
}

a {
	color: #007aff;
	text-decoration: none;
}

.paragraph {
}

.custom-counter {
	margin: 0;
	padding: 0;
	list-style-type: none;
}

.custom-counter li {
	counter-increment: step-counter;
	padding: 10px 0 10px 50px;
	position: relative;
}

.custom-counter li::before {
	content: counter(step-counter) ".";
	color: #535253;
	font-weight: bold;
	display: block;
	position: absolute;
	left: 25px;
}

button {
	float: right;
	width: 220px;
	height: 40px;
	border-radius: 20px;
	background-color: #36296f;
	font-family: Montserrat;
	font-size: 14px;
	font-weight: bold;
	font-style: normal;
	font-stretch: normal;
	line-height: normal;
	letter-spacing: 1px;
	text-align: center;
	color: #ffffff;
	cursor: pointer;
}

.custodian-name {
	font-weight: bold;
}

@media (max-width: 1215px) {
}
@media (max-width: 764px) {
}
@media (max-width: 640px) {
}
@media (max-width: 440px) {
}

@keyframes pulseLoader {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	45% {
		transform: scale(0.1);
		opacity: 0.7;
	}
	80% {
		transform: scale(1);
		opacity: 1;
	}
}
`, "",{"version":3,"sources":["webpack://./ClaimingTickets/claim-your-ticket/public/styleSheet.css"],"names":[],"mappings":"AAEA;CACC,qDAAqD;CACrD,eAAe;CACf,cAAc;AACf;AACA;CACC,kBAAkB;CAClB,eAAe;CACf,YAAY;AACb;AACA;CACC,YAAY;CACZ,WAAW;CACX,aAAa;AACd;;AAEA;CACC,YAAY;CACZ,gBAAgB;CAChB,uBAAuB;AACxB;AACA;CACC,qDAAqD;CACrD,eAAe;CACf,iBAAiB;CACjB,cAAc;CACd,gBAAgB;AACjB;;AAEA;CACC,qDAAqD;CACrD,eAAe;CACf,iBAAiB;CACjB,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,gCAAgC;CAChC,cAAc;AACf;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,cAAc;CACd,qBAAqB;AACtB;;AAEA;AACA;;AAEA;CACC,SAAS;CACT,UAAU;CACV,qBAAqB;AACtB;;AAEA;CACC,+BAA+B;CAC/B,yBAAyB;CACzB,kBAAkB;AACnB;;AAEA;CACC,kCAAkC;CAClC,cAAc;CACd,iBAAiB;CACjB,cAAc;CACd,kBAAkB;CAClB,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,uBAAuB;CACvB,eAAe;CACf,iBAAiB;CACjB,kBAAkB;CAClB,oBAAoB;CACpB,mBAAmB;CACnB,mBAAmB;CACnB,kBAAkB;CAClB,cAAc;CACd,eAAe;AAChB;;AAEA;CACC,iBAAiB;AAClB;;AAEA;AACA;AACA;AACA;AACA;AACA;AACA;AACA;;AAEA;CACC;EACC,mBAAmB;EACnB,UAAU;CACX;CACA;EACC,qBAAqB;EACrB,YAAY;CACb;CACA;EACC,mBAAmB;EACnB,UAAU;CACX;AACD","sourcesContent":["@import url(\"https://fonts.googleapis.com/css?family=Montserrat:300,700\");\r\n\r\nbody {\r\n\tfont-family: Montserrat, Arial, Helvetica, sans-serif;\r\n\tfont-size: 18px;\r\n\tcolor: #535253;\r\n}\r\ndiv.container {\r\n\tposition: relative;\r\n\tfont-size: 20px;\r\n\tmargin: auto;\r\n}\r\n.banner {\r\n\tmargin: auto;\r\n\twidth: 100%;\r\n\theight: 100px;\r\n}\r\n\r\n.content {\r\n\tmargin: auto;\r\n\tmax-width: 620px;\r\n\tpadding: 86px 30px 30px;\r\n}\r\nh1 {\r\n\tfont-family: Montserrat, Arial, Helvetica, sans-serif;\r\n\tfont-size: 36px;\r\n\tfont-weight: bold;\r\n\tcolor: #36296f;\r\n\tmargin: 0 0 30px;\r\n}\r\n\r\nh2 {\r\n\tfont-family: Montserrat, Arial, Helvetica, sans-serif;\r\n\tfont-size: 25px;\r\n\tfont-weight: bold;\r\n\tcolor: #2bb673;\r\n}\r\n\r\nhr {\r\n\tborder: none;\r\n\tborder-bottom: solid 1px #dadada;\r\n\tmargin: 34px 0;\r\n}\r\n\r\np {\r\n\tmargin: 0 0 1em;\r\n}\r\n\r\na {\r\n\tcolor: #007aff;\r\n\ttext-decoration: none;\r\n}\r\n\r\n.paragraph {\r\n}\r\n\r\n.custom-counter {\r\n\tmargin: 0;\r\n\tpadding: 0;\r\n\tlist-style-type: none;\r\n}\r\n\r\n.custom-counter li {\r\n\tcounter-increment: step-counter;\r\n\tpadding: 10px 0 10px 50px;\r\n\tposition: relative;\r\n}\r\n\r\n.custom-counter li::before {\r\n\tcontent: counter(step-counter) \".\";\r\n\tcolor: #535253;\r\n\tfont-weight: bold;\r\n\tdisplay: block;\r\n\tposition: absolute;\r\n\tleft: 25px;\r\n}\r\n\r\nbutton {\r\n\tfloat: right;\r\n\twidth: 220px;\r\n\theight: 40px;\r\n\tborder-radius: 20px;\r\n\tbackground-color: #36296f;\r\n\tfont-family: Montserrat;\r\n\tfont-size: 14px;\r\n\tfont-weight: bold;\r\n\tfont-style: normal;\r\n\tfont-stretch: normal;\r\n\tline-height: normal;\r\n\tletter-spacing: 1px;\r\n\ttext-align: center;\r\n\tcolor: #ffffff;\r\n\tcursor: pointer;\r\n}\r\n\r\n.custodian-name {\r\n\tfont-weight: bold;\r\n}\r\n\r\n@media (max-width: 1215px) {\r\n}\r\n@media (max-width: 764px) {\r\n}\r\n@media (max-width: 640px) {\r\n}\r\n@media (max-width: 440px) {\r\n}\r\n\r\n@keyframes pulseLoader {\r\n\t0% {\r\n\t\ttransform: scale(1);\r\n\t\topacity: 1;\r\n\t}\r\n\t45% {\r\n\t\ttransform: scale(0.1);\r\n\t\topacity: 0.7;\r\n\t}\r\n\t80% {\r\n\t\ttransform: scale(1);\r\n\t\topacity: 1;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
